import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PosthogService } from '../services/posthog.service';
import { ErrorModel } from '../models/error.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private posthogService!: PosthogService;

  constructor(private readonly injector: Injector) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 302) {
          return of(
            new HttpResponse({
              body: error.error || null,
              headers: error.headers,
              status: 302,
              statusText: 'Found',
              url: error.url || req.url,
            })
          );
        }

        const errorModel = error as ErrorModel;
        errorModel.userMessage =
          error.error?.message ?? error.error?.error ?? error.statusText;

        if (!this.posthogService) {
          this.posthogService = this.injector.get(PosthogService);
        }
        this.posthogService.trackApiError({
          url: req.url,
          status: error.status,
          message: errorModel.userMessage,
        });

        return throwError(() => errorModel);
      })
    );
  }
}
